import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './CustomizationSummarySectionContent.styles';
const Container = themeStyles.apply(Box, 'Container');
const Cards = themeStyles.apply(Box, 'Cards');
const Cta = themeStyles.apply(Box, 'Cta');
const CustomizationSummarySectionContent = ({ children, editLinkComponent, dataTestId = '', }) => (React.createElement(Container, { "data-testid": `${dataTestId}-section-content` },
    React.createElement(Cards, { "data-testid": `${dataTestId}-section-content-cards` }, children),
    React.createElement(Cta, null, editLinkComponent)));
export default CustomizationSummarySectionContent;
